import { layoutConstants } from "../constants";

const layoutReducer = (
  state = {
    scrolledToBottom: false,
  },
  action,
) => {
  switch (action.type) {
    case layoutConstants.LAYOUT_SCROLLED_TO_BOTTOM:
      return {
        ...state,
        scrolledToBottom: action.payload,
      };

    default:
      return state;
  }
};

export default layoutReducer;
